import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  documentName: string;
}
const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  documentName
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-1051">
      <div className="relative w-full max-w-md mx-auto bg-white rounded-lg shadow-lg p-6" data-id="element-1052">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-1053">
          <X size={20} data-id="element-1054" />
        </button>
        <div className="flex items-center mb-4 text-red-600" data-id="element-1055">
          <AlertTriangle size={24} className="mr-2" data-id="element-1056" />
          <h3 className="text-xl font-semibold" data-id="element-1057">Excluir relatório</h3>
        </div>
        <div className="mb-6" data-id="element-1058">
          <p className="text-gray-700 mb-4" data-id="element-1059">
            Tem certeza que deseja excluir o relatório de{' '}
            <strong data-id="element-1060">{documentName}</strong>?
          </p>
          <p className="text-gray-500 text-sm" data-id="element-1061">
            Esta ação não pode ser desfeita. Todos os dados do relatório serão
            perdidos permanentemente.
          </p>
        </div>
        <div className="flex justify-end space-x-3" data-id="element-1062">
          <button onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200" data-id="element-1063">
            Cancelar
          </button>
          <button onClick={onConfirm} className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" data-id="element-1064">
            Excluir
          </button>
        </div>
      </div>
    </div>;
};
export default DeleteConfirmationModal;